import React, { FunctionComponent } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import SimpleButton from '../../../../../common/components/presentation/simpleButton/SimpleButton';
import { IButtonProps } from '../ActionButtons';
import actionButtonsStyles from '../ActionButtonsStyles';
import Translation from '../../../../../gqlCommon/components/translation/Translation';

type IEnquireProps = IButtonProps & { disabled: boolean; isPrimary?: boolean; loading?: boolean };

const ContinueToCheckoutButton: FunctionComponent<IEnquireProps> = ({ onClick, disabled, loading }) => {
  const styles = actionButtonsStyles();

  return (
    <Box className={styles.item}>
      <SimpleButton
        buttonClassName={styles.continueButton}
        disabled={disabled || loading}
        type="filled"
        dataTest="customise:summary:continuetocheckoutv4"
        action={onClick}
      >
        {loading ? (
          <CircularProgress
            size={15}
            data-test="customize:summary:continuecheckoutv4:loader"
            className={styles.circularProgress}
          />
        ) : (
          <Typography variant="helpingText" className={styles.itemLabel}>
            <Translation id="trans__configurator__customise_page_ctas__continue_cta" />
          </Typography>
        )}
      </SimpleButton>
    </Box>
  );
};

export default ContinueToCheckoutButton;
